export default __webpack_public_path__ + "static/media/ShareNetwork.2a29d722.svg";